import { useMemo, useState } from "react";

function useOrderFilters(orders) {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const filteredOrders = useMemo(() => {
    return orders.filter((order) => {
      const searchText = search.toLowerCase();

      const customer =
        order.customerId?.name?.toLowerCase() || "";

      const food =
        order.foodId?.foodName?.toLowerCase() || "";

      const id =
        order._id?.toLowerCase() || "";

      const searchMatch =
        customer.includes(searchText) ||
        food.includes(searchText) ||
        id.includes(searchText);

      const statusMatch =
        status === "" || order.status === status;

      return searchMatch && statusMatch;
    });
  }, [orders, search, status]);

  return {
    search,
    setSearch,
    status,
    setStatus,
    filteredOrders,
  };
}

export default useOrderFilters;